import { render, staticRenderFns } from "./halLiveCoupon.vue?vue&type=template&id=c3cfadb4"
import script from "./halLiveCoupon.vue?vue&type=script&lang=js"
export * from "./halLiveCoupon.vue?vue&type=script&lang=js"
import style0 from "./halLiveCoupon.vue?vue&type=style&index=0&id=c3cfadb4&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports